<template>
  <div
    class="d-flex justify-content-center align-items-center"
    :class="wrapperClass"
  >
    <p v-if="message" class="text-center mb-3">{{ message }}</p>
    <span class="spinner-border text-primary"></span>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    message: String,
    wrapperClass: String
  }
}
</script>

<style lang="scss"></style>
